"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserProfileMapper = void 0;
const lodash_1 = __importDefault(require("lodash"));
class UserProfileMapper {
    toDomain(result) {
        const id = lodash_1.default.get(result, "data.getUser.id");
        const idHoldingView = lodash_1.default.get(result, "data.getUser.idHoldingView");
        const encodedIdHoldingView = lodash_1.default.get(result, "data.getUser.encodedIdHoldingView");
        const firstName = lodash_1.default.get(result, "data.getUser.firstName");
        const idGuest = lodash_1.default.get(result, "data.getUser.guests.edges[0].node.id");
        const holdingId = lodash_1.default.get(result, "data.getUser.currentHoldingView.holding.id");
        const holdingName = lodash_1.default.get(result, "data.getUser.currentHoldingView.holding.name");
        const holdingBrand = lodash_1.default.get(result, "data.getUser.currentHoldingView.holding.brand");
        const isLoading = lodash_1.default.get(result, "loading");
        const lastName = lodash_1.default.get(result, "data.getUser.lastName");
        const hardLinked = lodash_1.default.get(result, "data.getUser.hardLinked");
        const language = lodash_1.default.get(result, "data.getUser.language");
        const supportSerialNumber = lodash_1.default.get(result, "data.getUser.currentHoldingView.guest.supportSerialNumber");
        const serialNumber = lodash_1.default.get(result, "data.getUser.currentHoldingView.guest.serialNumber");
        const managementMode = lodash_1.default.get(result, "data.getUser.guests.edges[0].node.managementMode");
        const refillAllowedHolding = lodash_1.default.get(result, "data.getUser.currentHoldingView.holding.refillAllowed");
        const email = lodash_1.default.get(result, "data.getUser.email");
        const userOptins = lodash_1.default.get(result, "data.getUser.userOptins");
        const userOptouts = lodash_1.default.get(result, "data.getUser.userOptouts");
        const virtualTicket = lodash_1.default.get(result, "data.getUser.guests.edges[0].node.virtualTicket");
        const mfaEnabled = lodash_1.default.get(result, "data.getUser.mfaEnabled");
        const brandName = lodash_1.default.get(result, "data.getUser.currentHoldingView.holding.brandModel.name");
        const isBadgeRequired = lodash_1.default.get(result, "data.getUser.currentHoldingView.holding.isBadgeRequired");
        const isScolaPassCashSystem = lodash_1.default.get(result, "data.getUser.currentHoldingView.holding.isScolaPassCashSystem");
        const externalUrl = lodash_1.default.get(result, "data.getUser.currentHoldingView.holding.externalUrl");
        const idCashSystem = lodash_1.default.get(result, "data.getUser.currentHoldingView.holding.cashSystemInfo.id");
        const isSchool = lodash_1.default.get(result, "data.getUser.currentHoldingView.holding.isSchool");
        const refillAllowed = lodash_1.default.get(result, "data.getUser.currentHoldingView.holding.refillAllowed");
        const rating = lodash_1.default.get(result, "data.getUser.currentHoldingView.holding.rating");
        return {
            id,
            idGuest,
            idHoldingView,
            encodedIdHoldingView,
            firstName,
            hardLinked,
            lastName,
            holdingId,
            holdingName,
            holdingBrand,
            isLoading,
            badgeNumber: supportSerialNumber || serialNumber,
            managementMode,
            refillAllowedHolding,
            email,
            language,
            userOptins,
            userOptouts,
            virtualTicket,
            brandName,
            isBadgeRequired,
            isScolaPassCashSystem,
            externalUrl,
            idCashSystem,
            isSchool,
            refillAllowed,
            rating,
            mfaEnabled
        };
    }
}
exports.UserProfileMapper = UserProfileMapper;
